export var IdScene;
(function (IdScene) {
    IdScene["Loading"] = "Loading";
    IdScene["PlayerBase"] = "PlayerBase";
})(IdScene || (IdScene = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/scenes/types/IdScene.ts
// module id = 175
// module chunks = 3